import { Grid, Checkbox } from "@material-ui/core";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import StyledToolTip from "../../../../common/StyledToolTip";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import Dropdown from "../../../../common/Dropdown";

const UnassignPickupInfo = ({
  classes,
  stopDetails,
  isSelected,
  notes,
  color,
  driverDropdownErrorMessage,
  dispatchedDriversList,
  changeSelectedDriver,
  onUnassignPickupCheckboxClick,
}) => {
  return (
    <Grid container className={classes.containerStyle}>
      <Grid item xs={2} className={classes.unassignPickupCheckbox}>
        <Checkbox
          icon={<CheckBoxOutlineBlankIcon className={classes.sizeIcon} />}
          checkedIcon={<CheckBoxIcon className={classes.sizeIcon} />}
          classes={{
            root: classes.checkBoxStyle,
          }}
          color="primary"
          onClick={(e) => onUnassignPickupCheckboxClick(e, stopDetails)}
          checked={isSelected}
        />
        <div className={classes.iconStyle}>
          <StyledToolTip title={notes}>
            <ErrorOutlineIcon
              style={{ color: color, fontSize: 22 }}
            />
          </StyledToolTip>
        </div>
      </Grid>
      <Grid item xs={10}>
        <Grid container>
          <Grid item xs={7} className={classes.unassignShipperDetails}>
            <div className={classes.headerLabelStyle}>
              {stopDetails.shipperName}
            </div>
            <div className={classes.newDriverClass}>
              {`${stopDetails.shipperName} ${stopDetails.shipperZip}`}
            </div>
            {stopDetails.previousDriver ? (
              <div className={classes.newDriverClass}>
                <b>PREVIOUS DRIVER:</b>{" "}
                {`${stopDetails.previousDriver?.driverName} (${stopDetails.previousDriver?.driverNumber})`}
              </div>
            ) : null}
          </Grid>
          <Grid item xs={2}>
            <div className={classes.headerLabelStyle}>ETA</div>
            <div className={classes.newDriverClass}>
              {stopDetails.estimatedTimeOfArrival}
            </div>
          </Grid>
          <Grid item xs={3}>
            <div className={classes.headerLabelStyle}>Pickup window</div>
            <div
              className={classes.newDriverClass}
            >{`${stopDetails.pickupReadyTime} - ${stopDetails.pickupCloseTime}`}</div>
          </Grid>
          <Grid item xs={12}>
            <div className={classes.assignDriverClass}>
              <span className={classes.assignDriverLabel}>ASSIGN DRIVER:</span>
              <div className={classes.selectBox}>
                <Dropdown
                  placeholder="Select driver"
                  value={stopDetails.driverId ?? null}
                  options={dispatchedDriversList}
                  onChange={(value) => changeSelectedDriver(value, stopDetails)}
                  autoFocus={false}
                  customReactSelectClass={classes.reactSelect}
                />
                <span className={classes.dropdownError}>
                  {driverDropdownErrorMessage}
                </span>
              </div>
            </div>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
export default UnassignPickupInfo;
